import '@/styles/gmail.css';
import { registerAdminSection, registerGlobal, registerSlot } from '@/lib/slots';
import type { ClientArea } from '../types';
import { AccountInbox } from './AccountInbox';
import { EmailAdmin } from './EmailAdmin';
import { GmailReturn } from './GmailReturn';
import { useEmailAttention } from './queries';

// Gmail: your inbox connection in account settings, the "Email & inboxes" admin section, and the return from
// Google after connecting.

export const area: ClientArea = {
  name: 'gmail',
  setup() {
    registerSlot('account.inbox', AccountInbox);
    registerAdminSection({
      id: 'email',
      label: 'Email & inboxes',
      icon: 'mail',
      group: 'Workspace',
      order: 20,
      component: EmailAdmin,
      useAttention: useEmailAttention,
    });
    registerGlobal('gmail.return', GmailReturn);
  },
};
